<div class="ia-overlay" *ngIf="iaPainelAberto" (click)="painelFechado.emit()"></div>

<aside class="ia-produtos-painel" *ngIf="iaPainelAberto && iaProdutosPainelAberto">
  <div class="ia-painel-header ia-produtos-header">
    <div>
      <span>Produtos sugeridos</span>
      <h3>Segmento e historico do cliente</h3>
    </div>
    <button type="button" class="ia-close" (click)="produtosPainelFechado.emit()">x</button>
  </div>

  <div class="ia-contexto" *ngIf="clienteSelecionado != null">
    <strong>{{ clienteSelecionado.name }}</strong>
    <small>ERP: {{ clienteSelecionado.codigo_no_erp_do_cliente }} | Cliente ID: {{ clienteSelecionado.client_id_app }}</small>
  </div>

  <div class="ia-sugestoes ia-produtos-resultado" *ngIf="iaSugestao != null">
    <div class="ia-produtos-meta">
      <div class="ia-status" [ngClass]="iaSugestao.sucesso ? 'ia-ok' : 'ia-alerta'">{{ iaSugestao.mensagem }}</div>
      <small *ngIf="iaSugestao.data_pesquisa">Pesquisa: {{ iaSugestao.data_pesquisa | date:'dd/MM/yyyy HH:mm' }}</small>
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="sugestaoAtualizada.emit()" [disabled]="iaCarregando">Atualizar</button>
    </div>

    <div class="ia-sugestao-bloco">
      <div class="ia-sugestao-titulo">
        <strong>1. Produtos do segmento que o cliente nao compra</strong>
        <small>{{ produtosIaSegmentoNaoCompra().length }} item(ns)</small>
      </div>
      <ng-container *ngFor="let produto of produtosIaSegmentoNaoCompra()">
        <div class="ia-produto-compacto" (click)="produtoIaAlternado.emit(produto)">
          <strong>{{ produto.produto_nome }}</strong>
          <small>{{ produto.produto_codigo }} | {{ produto.preco_lista | currency:'BRL' }}</small>
          <span>{{ produto.estoque_atual | number:'1.0-0' }} est.</span>
        </div>
        <div class="ia-produto-detalhe" *ngIf="iaProdutoAberto === produto.product_id">
          <p><b>Argumento IA:</b> {{ produto.argumento_venda }}</p>
          <p><b>Preco atual:</b> {{ produto.preco_lista | currency:'BRL' }} | <b>Estoque:</b> {{ produto.estoque_atual | number:'1.0-0' }}</p>
          <div class="ia-condicoes" *ngIf="condicoesProdutoIa(produto).length > 0">
            <b>Condicoes especiais:</b>
            <span *ngFor="let condicao of condicoesProdutoIa(produto)">
              {{ condicao.tabela_especial_descricao }}: {{ condicao.preco_especial | currency:'BRL' }}
              <small *ngIf="condicao.qtd_minima">a partir de {{ condicao.qtd_minima | number:'1.0-0' }}</small>
            </span>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="ia-sugestao-bloco">
      <div class="ia-sugestao-titulo">
        <strong>2. Produtos que o cliente ja compra</strong>
        <small>{{ produtosIaClienteCompra().length }} item(ns)</small>
      </div>
      <ng-container *ngFor="let produto of produtosIaClienteCompra()">
        <div class="ia-produto-compacto" (click)="produtoIaAlternado.emit(produto)">
          <strong>{{ produto.produto_nome }}</strong>
          <small>{{ produto.produto_codigo }} | Atual: {{ produto.preco_lista | currency:'BRL' }}</small>
          <span *ngIf="produto.preco_especial">{{ produto.preco_especial | currency:'BRL' }}</span>
          <span *ngIf="!produto.preco_especial">{{ produto.estoque_atual | number:'1.0-0' }} est.</span>
        </div>
        <div class="ia-produto-detalhe" *ngIf="iaProdutoAberto === produto.product_id">
          <p><b>Ultima compra:</b> {{ produto.qtd_ultima_compra | number:'1.0-2' }} un. por {{ produto.preco_ultima_compra | currency:'BRL' }} em {{ produto.data_ultima_compra | date:'dd/MM/yyyy' }}</p>
          <p><b>Preco atual:</b> {{ produto.preco_lista | currency:'BRL' }} | <b>Estoque:</b> {{ produto.estoque_atual | number:'1.0-0' }}</p>
          <div class="ia-condicoes" *ngIf="condicoesProdutoIa(produto).length > 0">
            <b>Condicoes especiais:</b>
            <span *ngFor="let condicao of condicoesProdutoIa(produto)">
              {{ condicao.tabela_especial_descricao }}: {{ condicao.preco_especial | currency:'BRL' }}
              <small *ngIf="condicao.qtd_minima">a partir de {{ condicao.qtd_minima | number:'1.0-0' }}</small>
            </span>
          </div>
          <p><b>Segmento:</b> {{ produto.indicado_segmento ? 'Produto tambem indicado para o segmento.' : 'Produto do historico de compra do cliente.' }}</p>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="ia-loading" *ngIf="iaCarregando && iaSugestao == null">Buscando sugestoes de produtos...</div>
</aside>

<aside class="ia-painel-lateral" *ngIf="iaPainelAberto && !iaProdutosPainelAberto">
  <div class="ia-painel-header">
    <div>
      <span class="ia-painel-brand">IA NAPIS <small>NEW</small></span>
      <h3>Consultas inteligentes</h3>
    </div>
    <button type="button" class="ia-close" (click)="painelFechado.emit()">x</button>
  </div>

  <div class="ia-contexto" *ngIf="clienteSelecionado != null">
    <strong>{{ clienteSelecionado.name }}</strong>
    <small>ERP: {{ clienteSelecionado.codigo_no_erp_do_cliente }} | Cliente ID: {{ clienteSelecionado.client_id_app }}</small>
  </div>

  <div class="ia-empty ia-config-loading" *ngIf="iaConfiguracaoCarregando">
    Verificando configuracao da IA NAPIS...
  </div>

  <section class="ia-disabled-hero" *ngIf="!iaConfiguracaoCarregando && !moduloHabilitado()">
    <div class="ia-disabled-badge">Novo modulo</div>
    <h1>IA NAPIS</h1>
    <p>
      Use inteligencia artificial para tirar duvidas comerciais, consultar historico do cliente e sugerir produtos com dados reais do Napis.
    </p>
    <div class="ia-disabled-alert">
      Esta funcao ainda nao esta habilitada para a sua empresa. Entre em contato com o suporte para configurar a IA NAPIS.
    </div>
    <div class="ia-disabled-preview">
      <div class="ia-preview-chat">
        <strong>Chat inteligente</strong>
        <span>Respostas comerciais no contexto do cliente</span>
      </div>
      <div class="ia-preview-chat accent">
        <strong>Sugestao de produtos</strong>
        <span>Historico, preco, estoque e condicoes especiais</span>
      </div>
      <div class="ia-preview-chat success">
        <strong>Apoio ao vendedor</strong>
        <span>Argumentos tecnicos e aplicacoes do produto</span>
      </div>
    </div>
  </section>

  <ng-container *ngIf="!iaConfiguracaoCarregando && moduloHabilitado()">
    <div class="ia-chatbox">
      <div class="ia-chatbox-topo">
        <div>
          <strong>Chat IA</strong>
          <small>Ultimas 20 interacoes do vendedor</small>
        </div>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="historicoRecarregado.emit(true)" [disabled]="iaHistoricoCarregando || iaCarregando">
          Atualizar
        </button>
      </div>

      <div class="ia-chat-lista" #iaChatLista>
        <div class="ia-empty" *ngIf="iaHistoricoCarregando">Carregando historico da IA...</div>
        <div class="ia-empty" *ngIf="!iaHistoricoCarregando && iaMensagens.length === 0">
          Nenhuma conversa anterior com a IA.
        </div>

        <div class="ia-msg" *ngFor="let mensagem of iaMensagens" [ngClass]="mensagem.origem === 'USUARIO' ? 'ia-msg-user' : 'ia-msg-assistant'">
          <div class="ia-msg-label">
            <span>{{ mensagem.origem === 'USUARIO' ? 'Voce' : 'IA Napis' }}</span>
            <small *ngIf="mensagem.data">{{ mensagem.data | date:'dd/MM HH:mm' }}</small>
          </div>
          <div class="ia-status" *ngIf="mensagem.mensagem" [ngClass]="mensagem.sucesso ? 'ia-ok' : 'ia-alerta'">{{ mensagem.mensagem }}</div>
          <pre>{{ mensagem.texto }}</pre>
          <button *ngIf="mensagem.origem === 'IA'" type="button" class="btn btn-outline-primary btn-sm" (click)="textoIaCopiado.emit(mensagem.texto)">Copiar</button>
        </div>

        <div class="ia-digitando" *ngIf="iaCarregando">
          <span></span><span></span><span></span>
        </div>
      </div>

      <div class="ia-chat-input">
        <textarea class="form-control" rows="2" [ngModel]="iaPergunta" (ngModelChange)="iaPerguntaChange.emit($event)" placeholder="Pergunte para a IA..." (keydown.enter)="perguntaEnviadaPorEnter.emit($event)"></textarea>
        <button type="button" class="btn btn-primary" (click)="perguntaEnviada.emit()" [disabled]="iaCarregando || iaPergunta.trim() == ''">Enviar</button>
      </div>
    </div>
  </ng-container>
</aside>
